<template lang="pug">
v-layout
    //-v-app-bar.custom-toolbar.no-padding(color='white' height="60" absolute style="z-index:10;background: radial-gradient(circle, rgba(246,206,0,1) 0%, rgba(215,166,0,1) 100%);")
    //-v-app-bar.custom-toolbar.no-padding(color='white' height="60" absolute style="z-index:10;background: rgb(99,198,251);background: radial-gradient(circle, rgba(254,255,221,1) 0%, rgba(255,231,143,1) 100%);" v-if="notification")
        v-icon.pl-5 fas fa-exclamation-triangle
        //-p.pa-0.ma-0.ml-2(style="font-weight:bold;font-size:17px;line-height:18px;width:100%;color:rgba(0,0,0,0.8);").text-center AVISO: Por cambio de IP's públicas de los dominios del Ministerio de Educación, los sistemas de la UGPSEP <br>no estarán disponibles desde las 20:00 del 31 de marzo, hasta las 08:00 del 1 de abril
        p.pa-0.ma-0.ml-2(style="font-weight:bold;font-size:17px;line-height:18px;width:100%;color:rgba(0,0,0,0.8);").text-center AVISO: Por razones administrativas, los sistemas de la UGPSEP <br>no estarán disponibles desde las 20:00 del 31 de marzo, hasta las 08:00 del 1 de abril
        v-spacer
        v-btn(icon fab @click="notification=false").mr-2
            v-icon fas fa-times
    v-app-bar.custom-toolbar.no-padding(color='white' height="60" absolute style="z-index:10;background: rgb(99,198,251);background: radial-gradient(circle, rgba(254,255,221,1) 0%, rgba(255,231,143,1) 100%);" v-if="alerta")
        v-icon.pl-5 fas fa-exclamation-triangle
        //-p.pa-0.ma-0.ml-2(style="font-weight:bold;font-size:17px;line-height:18px;width:100%;color:rgba(0,0,0,0.8);").text-center AVISO: Por cambio de IP's públicas de los dominios del Ministerio de Educación, los sistemas de la UGPSEP <br>no estarán disponibles desde las 20:00 del 31 de marzo, hasta las 08:00 del 1 de abril
        p.pa-0.ma-0.ml-2(style="font-weight:bold;font-size:17px;line-height:18px;width:100%;color:rgba(0,0,0,0.8);" v-html="mensaje").text-center
        v-spacer
        v-btn(icon fab @click="alerta=false").mr-2
            v-icon fas fa-times
    v-app-bar.custom-toolbar.no-padding(color='white' app height="70" :style="alerta?'margin-top:60px':''")
        //-TEMP a.custom-logo.no-margin.no-padding(@click="goToHome" v-show="showLogo")
        //-v-btn(v-if="$store.state.loadingTabs" color="blue darken-4" fab text dark loading style="padding:0px;margin:0px;")
        v-custom-tabs(:callback="changeIframeBy" ref="customTabs")
        v-spacer
        v-idle.pa-0.ma-0.mr-4.subtitle-2.red--text(:events="[]" :duration="3600" :key="keyRerender" :reminders="[600]" @remind="showIdleTimer = true" @idle="endSession" :loop="false" v-show="false")
        v-divider(vertical)
        //-v-btn.txtn(v-if="!styleDocuments" style="border-bottom:#1A60C2 solid 3px;" @click="changeIframeByAndSetTab('/ui/ui-mis-documentos')" text large height="70").rounded-0
        v-btn.txtn(style="overflow:hidden;" :class="{ 'tab-active' : $store.state.tabDocument == true }" v-if="!styleDocuments && !$can(['manager.menu.cns','manager.menu.despacho'])" @click="changeIframeByAndSetTab('/ui/ui-mis-documentos')" text large height="70").rounded-0.tab-inactive
            v-icon(color="primary") far fa-folder-open
            | &nbsp;Mis Documentos
            div(v-show="$store.state.tabDocument" style="width:130%;height:10px;position:absolute;bottom:-31px;right:-22px;").primary
        //TODO:
        v-btn(v-else-if="!$can(['manager.menu.cns','manager.menu.despacho'])" large text style="width:60px;min-width:50px;height:62px" @click="changeIframeByAndSetTab('/ui/ui-mis-documentos')").mr-1.ml-1
            v-icon(color="primary") far fa-folder-open
        v-divider(vertical)
        v-user-options
        template(v-slot:extension v-if="showIdleTimer" transition="scale-transition")
            v-sheet(style="width:100%;").text-center
                v-app-bar(color="red" height="48px")
                    v-spacer
                    v-icon.mr-4 fas fa-exclamation-triangle
                    p.pa-0.ma-0.mr-1.subtitle-2.white--text Su sesión terminará en:
                    v-idle.pa-0.ma-0.mr-4.subtitle-2.white--text(:events="[]" :duration="600" :key="keyRerender" :loop="false")
                    v-btn(outlined color="white" @click="extendSession").txtn Extender sesión
                    v-spacer
                //-v-alert(color="red" dense type="success" width="100%" height="40px") Su sessión terminará en: 1:10 
    v-main(style="height:100%;overflow:hidden")
        iframe(:src="mySrc" frameborder="0" width="100%" height="100%" hspace="0" vspace="0" marginheight="0"  :style="alerta?'margin:0px;padding:0px;padding-top:60px;':'margin:0px;padding:0px;'")
    v-sheet(v-if="alertVersion" style="background:rgba(0,0,0,0);width:100%;position:fixed;bottom:15px;left:0px;pointer-events:none;z-index:9999999")
        v-alert(prominent type="info" color="blue darken-2" style="width:auto;max-width:456px;margin:0px auto;pointer-events:initial").pa-0.pl-5.rounded-lg
            v-card.transparent(flat)
                v-card-text.pa-3.pl-1.pb-0
                    h4.pb-1(style="font-size:16px;") Nueva versión del sistema disponible!
                    p(style="line-height:18px !important;").pa-0.ma-0 Está manejando una versión anterior del sistema, debe actualizar la página para cargar el nuevo contenido.
                v-card-actions.pt-2
                    v-btn.txt-normal(outlined color="white" @click="alertVersion = false" small) Cerrar
                    v-spacer
                    v-btn.txt-normal(color="success" @click="reloadPage").font-weight-bold Actualizar
        //-v-alert(prominent type="info" style="position:absolute;max-width:440px;bottom:0px;right:25%;left:50%;margin-left:-220px;").pa-0.pl-5
            v-card.transparent(flat)
                v-card-text.pa-3.pl-1.pb-0
                    span Nuevo contenido disponible,<br>Haga click en Actualizar para actualizar.
                v-card-actions
                    v-spacer
                    v-btn.blue.darken-2 Actualizar
        //-v-row(align="center")
            v-col.grow
                | Nuevo contenido disponible,<br>Haga click en Actualizar para actualizar.
        //-v-row(align="right")
            v-btn Actualizar
    v-dialog(v-model="isIdle" fullscreen persistent)
        v-card(color="rgba(0,20,50,0.7)" style="border-radius:0px;backdrop-filter: blur(3px);height:100%")
            v-card-text(style="height:100%;")
                v-container(bg fill-height grid-list-md text-xs-center)
                    v-layout(row wrap align-center)
                        v-flex
                            v-card(max-width="350" style="margin:0px auto;"  color="rgba(255,255,255,0.5)")
                                v-card-text.text-center(style="background-color:rgba(255,255,255,0.5)")
                                    v-icon(color="red darken-2" size="40").mt-2 fas fa-exclamation-triangle
                                v-card-text.text-center.pt-0.pb-3(style="background-color:rgba(255,255,255,0.5)")
                                    p.ma-0.pa-0.black--text.subtitle-2 Su sesión ha expirado<br>Inicie sesión para continuar
                                v-divider
                                v-card-actions
                                    v-spacer
                                    v-btn.txtn(color="blue darken-3" dark href="/portada").pl-3.pr-3 Iniciar sesión
                                    v-spacer
    v-dialog(v-model="$store.state.changePasswordDialog" persistent max-width="420px" overlay-opacity="0.6" overlay-color="#000")
        v-card(style="border-radius:10px;")
            v-card-text.pa-4.pb-2.text-center
                v-img(src="/img/shield.png" max-width="100px").center.mt-5
            v-card-text.pa-4.pb-3
                h3.text-center.blue--text.font-weight-regular(style="max-width:400px;font-size:20px;line-height:24px;").center Queremos asegurarnos<br>de que tu cuenta esté protegida.
                //-div(style="width:100%;height:1px;background-color:rgba(0,0,0,0.2)").mt-2.mb-2
                password(v-model="newPass" :strength-meter-only="true" @score="level")
                h3.text-center.blue-grey--text.text--darken-2.font-weight-regular(style="max-width:400px;font-size:16px;line-height:20px;margin-top:-10px !important;").center Por favor, cambia tu contraseña<br> por una distinta a tu fecha de nacimiento:
            v-card-text.pa-4.pb-0
                v-text-field(@keyup="changeInput" @keydown.tab.prevent="nextPass" label="Nueva contraseña:" v-model="newPass" :append-icon="showNewPass ? 'fas fa-eye' : 'fas fa-eye-slash'" :type="showNewPass ? 'password' : 'text'" @click:append="changeNewPass" ref="refNewPass" color="blue" outlined dense style="max-width:330px;border-radius:10px;" :rules="[rules.required, rules.min]").center
                v-text-field(@change="changeInput" @keydown.tab.prevent="nextRepeatPass" label="Repetir nueva contraseña:" v-model="repeatNewPass" :append-icon="showRepeatNewPass ? 'fas fa-eye' : 'fas fa-eye-slash'" :type="showRepeatNewPass ? 'password' : 'text'" @click:append="changeRepeatNewPass" ref="refRepeatNewPass" color="blue" outlined dense style="max-width:330px;border-radius:10px;" :rules="[rules.required, rules.min]").center
            v-card-actions.pt-0.pb-4
                h4(style="font-size:12px;" v-show="showLevel").font-weight-regular Tipo de contraseña: &nbsp;<br><span :style="styleNivelText">{{ nivelText }}</span>
                //-h4(:style="styleNivelText" v-show="showLevel").font-weight-regular {{ nivelText }}
                v-spacer
                v-btn(color="success" style="border-radius:10px;" @click="verifyPassword" :loading="loaderBtnSavePassword" ref="refBtnSave").pl-4.pr-4 Guardar
    v-dialog(v-model="confirmationDialog" max-width="420px")
        v-card(style="border-radius:10px;")
            v-card-text.pa-4.pb-2.text-center
                v-img(src="/img/shield-success.png" max-width="100px").center.mt-5
            v-card-text.pa-4.pb-5
                h3.text-center.green--text.font-weight-regular(style="max-width:400px;font-size:20px;line-height:24px;").center Contraseña modificada<br>correctamente !
                div(style="width:100%;height:1px;background-color:rgba(0,0,0,0.2)").mt-2.mb-2
                h3.text-center.blue-grey--text.text--darken-2.font-weight-regular(style="max-width:400px;font-size:16px;line-height:20px;").center.mt-1 ¡Gracias por tu colaboración<br>en mantener tu cuenta segura!
            v-card-actions.pb-4
                v-spacer
                v-btn(large color="success" style="border-radius:10px;" @click="confirmationDialog=false").pl-6.pr-6 Aceptar
                v-spacer
</template>

<style lang="stylus">
.tab-inactive
    border-bottom rgba(0,0,0,0) solid 0px
.tab-active
    border-bottom #1A60C2 solid 0px
</style>

<script>
import Password from 'vue-password-strength-meter'
export default {
    components: { Password },
    data: () => ({
        name: process.env.VUE_APP_ENVIRONMENT,
        showNewPass: true,
        showLevel: false,
        showRepeatNewPass: true,
        mySrc: '/home',
        currentTab: 0,
        alertVersion: false,
        version: null,
        showIdleTimer: false,
        keyRerender: 0,
        isIdle: false,
        alerta: false,
        mensaje: '',
        nivelText: '',
        loaderBtnSavePassword: false,
        newPass: '',
        repeatNewPass: '',
        confirmationDialog: false,
        styleNivelText: 'font-size:12px;',
        rules:{
            required: value => !!value || 'Este campo es requerido.',
            min: value => value.length >= 6 || 'Se requiere almenos 6 letras.',
        }
    }),
    computed:{
        showLogo(){
            if(this.$store.state.windowSize.w>550){
                return true;
            }
            else{
                return false;
            }
        },
        styleDocuments(){
            if(this.$store.state.windowSize.w<1100){
                return true;
            }
            else{
                return false;
            }
        }
    },
    methods:{
        level(event){
            if(event != null){
                if(event == 0){this.nivelText='Vulnerable';this.styleNivelText="font-size:12px;color:darkred"}
                else if(event == 1){this.nivelText='Insegura';this.styleNivelText="font-size:12px;color:#ff4500"}
                else if(event == 2){this.nivelText='Segura';this.styleNivelText="font-size:12px;color:orange"}
                else if(event == 3){this.nivelText='Fuerte';this.styleNivelText="font-size:12px;color:#81b90e"}
                else if(event == 4){this.nivelText='Altemente Segura';this.styleNivelText="font-size:12px;color:green"}
                else{this.nivelText='';this.styleNivelText="font-size:12px;"}
            }
        },
        changeInput(event){
            if(this.newPass.length>5 || this.repeatNewPass.length>5){
                this.showLevel = true;

            }
            else{
                this.showLevel = false;
            }
        },
        changeNewPass(){
            this.showNewPass = !this.showNewPass;
            return this.$refs.refNewPass.focus();
        },
        changeRepeatNewPass(){
            this.showRepeatNewPass = !this.showRepeatNewPass;
            return this.$refs.refRepeatNewPass.focus();
        },
        nextPass(){
            this.$refs.refRepeatNewPass.focus();
        },
        nextRepeatPass(){
            setTimeout(() => {
                this.$refs.refBtnSave.$el.focus();
            })
        },
        extendSession(){
            this.keyRerender += 1;
            this.showIdleTimer = false;
        },
        endSession(){
            this.isIdle = true;
            localStorage.clear();
        },
        changeIframeByAndSetTab(src){
            this.$store.state.tabDocument=true
            this.$refs.customTabs.showInvisible()
            if(this.$store.state.version == null){
                this.mySrc = src + '?version=' + document.title.substr(document.title.length - 5);
            }
            else{
                this.mySrc = src + '?version=' + this.$store.state.version
            }
        },
        changeIframeBy(src){
            this.$store.state.tabDocument=false
            if(this.$store.state.version == null){
                this.mySrc = src + '?version=' + document.title.substr(document.title.length - 5);
            }
            else{
                this.mySrc = src + '?version=' + this.$store.state.version
            }
        },
        goToHome(){
            this.mySrc = "/home"
            this.currentTab = 0
        },
        reloadPage(){
            if(this.$store.state.version == null){
                window.location = window.location.href+'?version=' + document.title.substr(document.title.length - 5);
            }
            else{
                window.location = window.location.href+'?version=' + this.$store.state.version
            }
        },
        async checkVersionInit(){
            try {
                let ran = Math.floor(Math.random() * (999999 - 1 + 1) + 1);
                let url = "/info/sisep-info";
                //let url = "http://100.0.102.26:8103/sisep-info";
                let resp = await axios.get(url+"?ver="+ran.toString());
                if(resp.data.version !== document.title.substr(document.title.length - 5)){
                    this.alertVersion = true;
                    this.$store.state.version = resp.data.version;
                }
                else{
                    this.alertVersion = false
                }
                if(resp.data.alerta == true){
                    this.alerta = true;
                    this.mensaje = resp.data.mensaje;
                }
                else{
                    this.alerta = false;
                }
            } catch (error) {
                this.alertVersion = false;
                this.alerta = false;
            }
        },
        async checkVersion(){
            setInterval(async function(){
                try {
                    let ran = Math.floor(Math.random() * (999999 - 1 + 1) + 1);
                    let url = "/info/sisep-info";
                    //let url = "http://100.0.102.26:8103/sisep-info";
                    let resp = await axios.get(url+"?ver="+ran.toString());
                    if(resp.data.version !== document.title.substr(document.title.length - 5)){
                        this.alertVersion = true;
                        this.$store.state.version = resp.data.version;
                    }
                    else{
                        this.alertVersion = false
                    }
                    if(resp.data.alerta == true){
                        this.alerta = true;
                        this.mensaje = resp.data.mensaje;
                    }
                    else{
                        this.alerta = false;
                    }
                } catch (error) {
                    this.alertVersion = false;
                    this.alerta = false;
                }
            }.bind(this),120000);
        },
        checkHash(){
            if(window.location.hash) {
                var hash = window.location.hash.substring(1);
                console.log("EXIST: " + hash);
                /*switch (window.location.hash) {
                    case '': {break;}
                    default: break;
                }*/
            }
        },
        async verifyPassword(){
            if(this.repeatNewPass != this.newPass){
                this.$snotify.error("Las contraseñas deben coincidir.",{timeout:8000});
            }
            else{
                if(this.repeatNewPass.length>=6){
                    this.saveNewPassword();
                }
                else{
                    this.$snotify.error("Las contraseñas deben tener al menos 6 caracteres.",{timeout:8000});
                }
            }
        },
        async saveNewPassword(){
            try {
                this.loaderBtnSavePassword = true;
                let resp = await axios.post(
                    'https://sisep.minedu.gob.bo/db-service/db-service-oauth-acl/api/v2/change-default-password',
                    {pass:this.newPass},
                    {headers:{'Content-Type':'application/json','Accept':'application/json','Authorization':'Bearer '+this.$store.state.token}}
                );
                if(resp.data.status == "OK"){
                    //this.$snotify.info("CONTRASEÑA MODIFICADA CORRECTAMENTE");
                    this.$store.state.changePasswordDialog = false;
                    this.confirmationDialog = true;
                }
                else{
                    this.$snotify.error(resp.data.status,{timeout:10000});
                    this.loaderBtnSavePassword = false;
                }
            }
            catch (error) {
                this.$snotify.error("No fué posible cambiar su contraseña");
                console.log(error)
                this.loaderBtnSavePassword = false;
            }
        }
    },
    mounted(){
        //this.checkHash();
        this.checkVersionInit();
    },
    async created(){
        await this.$store.dispatch('verificarToken')
        if(this.$store.state.changePasswordDialog){
            this.$refs.refNewPass.focus();
        }
        this.checkVersion();
    }
}
</script>
